import { render, staticRenderFns } from "./nojoin.vue?vue&type=template&id=a55d4214&scoped=true"
import script from "./nojoin.vue?vue&type=script&lang=js"
export * from "./nojoin.vue?vue&type=script&lang=js"
import style0 from "./nojoin.vue?vue&type=style&index=0&id=a55d4214&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55d4214",
  null
  
)

export default component.exports